// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import { GoogleOAuthProvider } from '@react-oauth/google';
import './App.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './context/AuthContext';
import { ModalProvider } from './context/ModalContext';
import './App.css';       // Core variables & resets
import './Components.css'; // UI Components
import './Pages.css';
import './darkMode.css';

// --- SERVICE WORKER REGISTRATION ---
// FIX: Only register service worker in production to prevent HMR errors in dev
if ('serviceWorker' in navigator) {
  if (process.env.NODE_ENV === 'production') {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/service-worker.js')
        .then((registration) => {
          console.log('✅ ServiceWorker registration successful with scope: ', registration.scope);
        })
        .catch((err) => {
          console.log('❌ ServiceWorker registration failed: ', err);
        });
    });
  } else {
    // In development, explicitly unregister any existing sw to clear the cache
    navigator.serviceWorker.ready.then(registration => {
      registration.unregister();
      console.log('🛑 ServiceWorker unregistered (Development Mode)');
    }).catch(error => {
      console.error(error.message);
    });
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
      <AuthProvider>
        <ModalProvider> 
            <App />
        </ModalProvider>
      </AuthProvider>
    </GoogleOAuthProvider>
);

reportWebVitals();